import { render, staticRenderFns } from "./OpenBill.vue?vue&type=template&id=2f675003&scoped=true"
import script from "./OpenBill.vue?vue&type=script&lang=ts"
export * from "./OpenBill.vue?vue&type=script&lang=ts"
import style0 from "./OpenBill.vue?vue&type=style&index=0&id=2f675003&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f675003",
  null
  
)

export default component.exports